import styled from 'styled-components';
import { SVGIcon, Button } from '@pearsontechnology/aero-components';
import { ModalContent as ModalContentComponent } from 'components/Modal';
import { UPLOAD_FAILED } from './constants';

export const ModalContent = styled(ModalContentComponent)`
  padding-top: 0px;
`;

export const Spacer = styled.div`
  height: 28px;
`;

export const InputWithoutErrorWarningIcon = styled.div`
  svg {
    display: none;
  }
`;

export const ImportFileDropZoneLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
`;

export const UploadFileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 30px 30px 30px;
`;

export const FileNameWrapper = styled.p`
  display: flex;
  margin-right: 20px;
  word-break: break-word;
`;

export const FileIcon = styled(SVGIcon)`
  opacity: 0.6;
  margin-right: 5px;
`;

export const ProgressIndicator = styled.div`
  margin: 0 auto;
  font-weight: 600;
  font-size: 23px;  
  padding: 15px;
`;

export const WarningIcon = styled.p`
  color: ${(props) => props.uploadState && props.theme['color.greenLight']};
  opacity:  ${(props) => props.uploadState ? 1 : 0.5};
  width: 30px;
`;

export const ErrorWarningIcon = styled.p`
  color: ${(props) =>
    props.theme.themeId === 'dark'
      ? props.theme['color.redLight']
      : props.theme['color.redDark']};
  margin: 5px;
  width: 30px;
`;

export const WarningWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 15px;
  margin: 0 auto;
  color: ${(props) =>
    props.theme.themeId === 'dark'
      ? (props.uploadState === UPLOAD_FAILED && props.theme['color.redLight'])
      : (props.uploadState === UPLOAD_FAILED && props.theme['color.redDark'])};
`;

export const UploadFileCancelButton = styled(Button)`
  align-self: flex-end;
`;



